import { render, staticRenderFns } from "./goodsRecommendTab.vue?vue&type=template&id=7c3e85c8&scoped=true&"
import script from "./goodsRecommendTab.vue?vue&type=script&lang=js&"
export * from "./goodsRecommendTab.vue?vue&type=script&lang=js&"
import style0 from "./goodsRecommendTab.vue?vue&type=style&index=0&id=7c3e85c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3e85c8",
  null
  
)

export default component.exports